import { createContext } from "solid-js";

interface AppLayoutContextValue {
  committedPath: () => string;
}

export const AppLayoutContext = createContext<AppLayoutContextValue>();
